import { render, staticRenderFns } from "./RelatorioTestesMainPanel.vue?vue&type=template&id=af640f22&scoped=true&"
import script from "./RelatorioTestesMainPanel.vue?vue&type=script&lang=js&"
export * from "./RelatorioTestesMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af640f22",
  null
  
)

export default component.exports